/// <reference path="../../HTML/Tag.ts" />
/// <reference path="../Controller.ts" />
namespace HA.Core.Controller.Form {
    import Tag = HA.Core.HTML.Tag;
    import FormItem = HA.Core.HTML.Form.FormItem;
    import Select = HA.Core.HTML.Form.Select;

    export class FormItemController extends Controller {
        public static TYPE_BTN_ITEM = "Button";

        /**
         *
         * @param data
         * @returns {FormItemController}
         */
        public static createController(data: Map<any, any>) {
            const tag = new Tag(data);
            const element = tag.findByAttribute("ft");
            if (element) {
                switch (element.getAttribute("ft")) {
                    case "mslct" :
                    case "slct" :
                        return new SelectController(data);
                    case "txt" :
                        data.set("textarea", 1);
                    case "txtl" :
                        return new TextController(data);
                    case "mtxt" :
                        return new MultiTextController(data);
                    case "fs" :
                        return new FileController(data);
                    case "mm" :
                        return new MultiMediaController(data);
                    case "checkbox" :
                        return new CheckboxController(data);
                    default:
                        break;
                }

                return new FormItemController(data);
            }
        }

        public reset() {
            this.getTag().reset();
        }

        /**
         *
         * @returns {any|string}
         */
        public getValue() {
            return this.getTag().getValue();
        }

        /**
         *
         * @returns {boolean}
         */
        public isInputItem() {
            return false;
        }

        /**
         *
         * @returns {any}
         */
        public getItemType() {
            return this.getTag().getType();
        }

        /**
         *
         * @returns {any|string}
         */
        public getName() {
            return this.getTag().getName();
        }

        /**
         * @returns {HA.Core.HTML.Form.Select}
         */
        public getTag() {
            return super.getTag();
        }

        public getTitle() {
            return this.getTag().getTitle();
        }

        public getAttr(name: string) {
            return this.getTag().getAttr(name);
        }

        /**
         * @param data
         */
        protected initialize(data: Map<any, any>) {
            super.initialize(data);
            this.initItem();
        }

        protected initItem() {
            this.setTag(this.createItem());
        }

        /**
         *
         * @returns {any}
         */
        protected createItem() {
            const element = this.getTag().findByAttribute("ft");
            const data = toMap({tag: this.getTag()});
            const me = this;
            let t: string = "FormItem";
            if (element) {
                switch (element.getAttribute("ft")) {
                    case "btn" :
                        t = FormItemController.TYPE_BTN_ITEM;
                        data.set("click", () => {
                            me.getFormController().processBtnClick(me.getTag());
                        });
                        break;
                    default:
                        break;
                }
            }

            this.addToData("itemType", t);

            return createService(HA.Core.HTML.Form, t, data);
        }

        /**
         *
         * @param items
         */
        protected replaceItems(items: any[]) {
            this.getTag().replaceItems(items);
        }

        /**
         *
         * @returns {Map}
         */
        protected getChoices() {
            return this.getTag().getChoices();
        }

        /**
         *
         * @returns {FormController}
         */
        protected getFormController() {
            return this.get("formController");
        }

        protected setAppId(id: string) {
            return this.addToData("_appId", id);
        }

        protected getAppId() {
            return this.get("_appId");
        }

    }
}
